export default {
  environment: process.env.NODE_ENV,
  api: process.env.VUE_APP_API_URL,
  web: process.env.VUE_APP_WEB_URL,
  self: process.env.VUE_APP_SELF_URL,
  mixpanelToken: process.env.VUE_APP_MIXPANEL_TOKEN,
}
